/**
 * Admin API client. Wraps axios with the JWT bearer stored in localStorage.
 */
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const ADMIN_BASE = `${BACKEND_URL}/api/admin`;
export const TOKEN_KEY = "mist_admin_token";

export const adminApi = axios.create({ baseURL: ADMIN_BASE, timeout: 20000 });

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      if (window.location.pathname.startsWith("/admin") && !window.location.pathname.startsWith("/admin/login")) {
        window.location.href = "/admin/login?expired=1";
      }
    }
    return Promise.reject(err);
  }
);

export function saveToken(t) {
  localStorage.setItem(TOKEN_KEY, t);
}
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}
export function hasToken() {
  return !!localStorage.getItem(TOKEN_KEY);
}
